import { withTranslation } from 'react-i18next'
import DeleteModal from './DeleteModal'

export default withTranslation()(DeleteModal)
